export default __webpack_public_path__ + "static/media/IMG_013_finished.5d596a3c.jpg";